
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { AppHostnameMixin, BAIconsMixin, StringsMixin, HelpInfoMixin } from '@/mixins';

@Component
export default class ShareableProfileInfo extends Mixins(AppHostnameMixin, BAIconsMixin, StringsMixin, HelpInfoMixin) {
	// @Prop() value: boolean;										// inherited. indicates whether the data is being shared or not
	// @Prop({ type: Boolean }) showHelp;							// inherited. indicates if help is being displayed
	@Prop({ type: String, default: undefined }) icon: string;		// displayed on the left
	@Prop({ type: String, default: undefined }) label: string;		// displayed on the left side
	@Prop({ type: String, required: true }) data: string;			// displayed on the right
	@Prop({ type: Boolean, default: true }) dataCheck;				// perform a data check. if no check required, display blank
	@Prop({ type: Boolean }) simple;								// display label: value
	@Prop({ type: Boolean }) noLabel;								// do not display the label if data is available
	@Prop({ type: Boolean }) email;									// if the data is email
	@Prop({ type: Boolean }) clipboard;								// if the data can be copied to clipboard
}
